import React, { useState } from 'react';
import { X, CircleCheck as CheckCircle } from 'lucide-react';
import { Button } from '../ui/Button';

interface ResolveNoteModalProps {
  orderReference: string;
  onConfirm: (note?: string) => void;
  onClose: () => void;
}

export const ResolveNoteModal: React.FC<ResolveNoteModalProps> = ({
  orderReference,
  onConfirm,
  onClose,
}) => {
  const [note, setNote] = useState('');

  return (
    <tr>
      <td colSpan={9}>
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
            <div className="flex items-center justify-between p-5 border-b border-gray-200 dark:border-gray-700">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-emerald-500 to-green-600 flex items-center justify-center">
                  <CheckCircle className="h-5 w-5 text-white" />
                </div>
                <div>
                  <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100">
                    Resolve Issue
                  </h2>
                  <p className="text-sm text-gray-500 dark:text-gray-400">
                    {orderReference}
                  </p>
                </div>
              </div>
              <button
                onClick={onClose}
                className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
              >
                <X className="h-5 w-5 text-gray-500" />
              </button>
            </div>

            <div className="p-5">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Resolution note (optional)
              </label>
              <textarea
                value={note}
                onChange={(e) => setNote(e.target.value)}
                rows={3}
                placeholder="e.g., Fixed postal code from 1234AB to 1234 AB"
                className="w-full px-3 py-2.5 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 text-sm focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 resize-none"
              />
            </div>

            <div className="flex items-center justify-end gap-3 p-5 border-t border-gray-200 dark:border-gray-700">
              <Button variant="secondary" onClick={onClose}>
                Cancel
              </Button>
              <Button onClick={() => onConfirm(note || undefined)}>
                Resolve
              </Button>
            </div>
          </div>
        </div>
      </td>
    </tr>
  );
};
